(() => {
  const root = document.getElementById('rf-rug-model-rows');
  if (!root) return;
  const form = root.querySelector('[data-rf-filter-form]');
  if (!form) return;
  const sizeInputs = [...form.querySelectorAll('[data-rf-size-option]')];
  const shapeInputs = [...form.querySelectorAll('[data-rf-shape-option]')];
  const cards = [...root.querySelectorAll('[data-rf-design]')];
  const models = [...root.querySelectorAll('[data-rf-model]')];
  const counter = form.querySelector('[data-rf-results-count]');
  const empty = root.querySelector('[data-rf-no-results]');
  const sizeBadge = form.querySelector('[data-rf-size-count]');
  const shapeBadge = form.querySelector('[data-rf-shape-count]');
  const sizeDetails = form.querySelector('[data-rf-size-details]');
  const sizeSearch = form.querySelector('[data-rf-size-search]');
  const sizeScroll = form.querySelector('[data-rf-size-scroll]');
  const sizeEmpty = form.querySelector('[data-rf-size-empty]');
  const filterDetails = [...form.querySelectorAll('.rf-rmr__filter')];

  const query = new URLSearchParams(window.location.search);
  const fromQuery = key => (query.get(key) || '').split(',').map(s => s.trim()).filter(Boolean);
  const initialSizes = new Set(fromQuery('rf_size'));
  const initialShapes = new Set(fromQuery('rf_shape'));
  for (const box of sizeInputs) box.checked = initialSizes.has(box.value);
  for (const box of shapeInputs) box.checked = initialShapes.has(box.value);

  const checked = inputs => inputs.filter(input => input.checked).map(input => input.value);
  const update = () => {
    const sizes = checked(sizeInputs);
    const shapes = checked(shapeInputs);
    let visible = 0;
    for (const card of cards) {
      const cardSizes = (card.dataset.rfSizes || '').split('|');
      const matchedSize = !sizes.length || sizes.some(size => cardSizes.includes(size));
      const matchedShape = !shapes.length || shapes.includes(card.dataset.rfShape);
      card.hidden = !(matchedSize && matchedShape);
      if (!card.hidden) visible++;
    }
    for (const model of models) {
      model.hidden = !model.querySelector('[data-rf-design]:not([hidden])');
    }
    sizeBadge.hidden = !sizes.length;
    shapeBadge.hidden = !shapes.length;
    sizeBadge.textContent = sizes.length ? '(' + sizes.length + ')' : '';
    shapeBadge.textContent = shapes.length ? '(' + shapes.length + ')' : '';
    if (counter) counter.textContent = visible + ' rug products match this page';
    if (empty) empty.hidden = visible > 0 || cards.length === 0;
  };

  const filterSizes = () => {
    const term = (sizeSearch?.value || '').toLowerCase().replace(/×/g,'x').replace(/\s+/g,'');
    let found = 0;
    for (const input of sizeInputs) {
      const label = input.closest('label');
      const matches = !term || input.value.toLowerCase().replace(/×/g,'x').replace(/\s+/g,'').includes(term);
      if (label) label.hidden = !matches;
      if (matches) found++;
    }
    if (sizeEmpty) sizeEmpty.hidden = found > 0;
  };

  for (const details of filterDetails) {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      for (const other of filterDetails) if (other !== details) other.open = false;
      if (details === sizeDetails) {
        if (sizeScroll) sizeScroll.scrollTop = 0;
      }
    });
  }
  if (sizeSearch) sizeSearch.addEventListener('input', filterSizes);
  form.querySelector('[data-rf-clear-sizes]')?.addEventListener('click', () => {
    for (const input of sizeInputs) input.checked = false;
    if (sizeSearch) sizeSearch.value = '';
    filterSizes();
    update();
  });
  form.querySelector('[data-rf-close-size]')?.addEventListener('click', () => {
    if (sizeDetails) sizeDetails.open = false;
  });
  document.addEventListener('click', event => {
    if (!form.contains(event.target)) {
      for (const details of filterDetails) details.open = false;
    }
  });
  form.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      for (const details of filterDetails) details.open = false;
      const summary = event.target.closest('details')?.querySelector('summary');
      if (summary) summary.focus();
    }
  });
  for (const box of [...sizeInputs, ...shapeInputs]) box.addEventListener('change', update);
  form.addEventListener('submit', event => {
    event.preventDefault();
    const target = new URL(form.action, window.location.href);
    const data = new FormData(form);
    for (const [key, value] of data.entries()) {
      if (typeof value === 'string' && value.trim()) target.searchParams.append(key, value);
    }
    const sizes = checked(sizeInputs);
    const shapes = checked(shapeInputs);
    if (sizes.length) target.searchParams.set('rf_size', sizes.join(','));
    if (shapes.length) target.searchParams.set('rf_shape', shapes.join(','));
    window.location.assign(target.toString());
  });

  update();
})();